import React, { useState } from 'react';
import { Container, Form, Button, Card, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

// Tarea 027b — solicita el link de recuperación. Respuesta siempre genérica
// (anti-enumeración), igual que el reenvío de verificación de correo.
const ForgotPasswordPage = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'sent'

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        try {
            await api.post('/auth/forgot-password', { email });
        } finally {
            setStatus('sent');
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <Row>
                <Col>
                    <Card style={{ width: '24rem' }}>
                        <Card.Body>
                            <Card.Title className="text-center mb-4">{t('forgotPasswordPage.title')}</Card.Title>

                            {status === 'sent' ? (
                                <Alert variant="success">{t('forgotPasswordPage.success')}</Alert>
                            ) : (
                                <>
                                    <p className="text-center text-muted mb-4">{t('forgotPasswordPage.subtitle')}</p>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3" controlId="email">
                                            <Form.Label>{t('forgotPasswordPage.emailLabel')}</Form.Label>
                                            <Form.Control
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                placeholder={t('forgotPasswordPage.emailPlaceholder')}
                                                required
                                            />
                                        </Form.Group>
                                        <div className="d-grid">
                                            <Button variant="primary" type="submit" disabled={status === 'sending'}>
                                                {status === 'sending'
                                                    ? t('forgotPasswordPage.sending')
                                                    : t('forgotPasswordPage.submitButton')}
                                            </Button>
                                        </div>
                                    </Form>
                                </>
                            )}

                            <div className="text-center mt-3">
                                <Link to="/login">{t('forgotPasswordPage.backToLogin')}</Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ForgotPasswordPage;
